<template>
  <div id="app">
    <v-app id="inspire">
      <v-navigation-drawer v-model="drawer" app clipped>
        <v-list dense>
          <v-list-item link @click="go('/')">
            <v-list-item-action>
              <v-icon>mdi-file-cog</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title style="text-align: left">Processar Arquivo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item link @click="go('/arquivos')">
            <v-list-item-action>
              <v-icon>mdi-file-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title style="text-align: left">Meus Arquivos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app clipped-left>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>SPED Fiscal - Antecipação Tributária</v-toolbar-title>
      </v-app-bar>

      <v-main>
        <v-container class="fill-height" fluid>
          <router-view />
        </v-container>
      </v-main>

      <v-footer app>
        <span>&copy; Anron Software - {{ new Date().getFullYear() }}</span>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
  }),
  created() {
    this.$vuetify.theme.dark = true;
  },
  methods: {
    go(value) {
      if (value !== this.$router.history.current.fullPath) {
        this.$router.push(value);
      }
      this.drawer = false;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
